import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Col, Form, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import Select from 'react-select';
import { AdvancedSearchTerm, SearchTerm } from '../../utils/searchUtils';
import { SelectStyles } from '../../../style/components/react-select';
import CloseIcon from '../Icons/CloseIcon';

function SearchAdvancedRow({
  metatagOptions,
  onRemoveClick,
  onDataChange,
  rowIndex,
  searchTerm,
  intl,
}) {
  const operatorOptions = [
    { value: 'AND', label: intl.formatMessage({ id: 'searchBar.advancedForm.operatorAnd' }) },
    { value: 'OR', label: intl.formatMessage({ id: 'searchBar.advancedForm.operatorOr' }) },
    { value: 'NOT', label: intl.formatMessage({ id: 'searchBar.advancedForm.operatorNot' }) },
  ];
  // const searchOptions = [
  //   { value: 'CONTAIN', label: intl.formatMessage({ id: 'searchBar.advancedForm.searchContainS' }) },
  //   { value: 'NOT CONTAIN', label: intl.formatMessage({ id: 'searchBar.advancedForm.searchNotContain' }) },
  //   { value: 'STARTS WITH', label: intl.formatMessage({ id: 'searchBar.advancedForm.searchStartsWith' }) },
  //   { value: 'ENDS WITH', label: intl.formatMessage({ id: 'searchBar.advancedForm.searchEndsWith' }) },
  // ];

  const onMetatagChange = (e) => {
    let newSearchTerm;
    if (e && e.value) {
      const [tagCategory, tagName] = e.value.split('.');
      const options = {
        type: e.type,
        operator: searchTerm.operator,
      };
      newSearchTerm = new AdvancedSearchTerm(tagCategory, tagName, searchTerm.value, options);
    } else {
      newSearchTerm = new SearchTerm('DEFAULT', searchTerm.value, { operator: searchTerm.operator });
    }

    onDataChange(rowIndex, newSearchTerm);
  };

  const helpTooltip = (
    <Popover id="search-help-tooltip" data-html="true" className="search-advanced__help-tooltip">
      <div>
        <FormattedMessage
          id="searchBar.advancedForm.helpTooltip.content"
          values={{
            numberText: <em>number</em>,
            dateText: <em>date</em>,
            rangeExample: <strong>RANGE:value1,value2</strong>,
            lessExample: <strong>LESS:value</strong>,
            greaterExample: <strong>GREATER:value</strong>,
            br: <br />,
            example1: 'greater:10-OCT-2019',
            example2: 'range:10/10/2019,20/10/2019',
            example3: 'less:100',
            example4: 'range:12,600',
          }}
        />
      </div>
    </Popover>
  );

  return (
    <Row className="search-advanced__row" key={rowIndex}>
      {rowIndex === 0 ? null : (
        <div className="search-advanced__operator">
          <Select
            size="sm"
            className="search-advanced__operator-select col-sm-3"
            onChange={(e) => onDataChange(rowIndex, searchTerm.set('operator', e.value))}
            value={operatorOptions.find(option => option.value === searchTerm.operator)}
            options={operatorOptions}
            styles={SelectStyles}
          />
        </div>
      )}
      <div className="search-advanced__meta-select-col">
        <Select
          value={metatagOptions
            ?.map(group => group.options)
            ?.flat()
            ?.find(option => option.value === searchTerm.fullName)
            || (searchTerm.name ? { value: searchTerm.name, label: searchTerm.name } : null)}
          size="sm"
          className="search-advanced__metatag-select"
          placeholder={intl.formatMessage({ id: 'searchBar.advancedForm.anyMetatagOption' })}
          onChange={onMetatagChange}
          multiselect={false}
          options={metatagOptions}
          openOnFocus
          isClearable
          styles={SelectStyles}
        />
      </div>
      {/* <Col md={3}>
        <Select
          value={searchTerm.searchOption || searchOptions[0]}
          size="sm"
          className="search-advanced__metatag-select"
          onChange={(e) => onDataChange(rowIndex, searchTerm.set('searchOption', e.value))}
          multiselect={false}
          options={searchOptions}
          openOnFocus
          styles={SelectStyles}
        />
      </Col> */}
      <div className="search-advanced__meta-select-col">
        <Form.Control
          size="md"
          placeholder={intl.formatMessage({ id: 'searchBar.advancedForm.searchTermPlaceholder' })}
          onChange={(e) => onDataChange(rowIndex, searchTerm.set('value', e.target.value))}
          value={searchTerm.value || ''}
          type="text"
          className="search-advanced__metatag-input"
        />
      </div>
      {['NUMBER', 'DATE'].includes(searchTerm.type) ? (
        <div className="search-advanced__meta-icon-col">
          <OverlayTrigger placement="left" overlay={helpTooltip}>
            <span
              className="far fa-question-circle search-advanced__help"
              aria-hidden="true"
            />
          </OverlayTrigger>
        </div>
      ) : null}
      <div className="search-advanced__meta-icon-col search-advanced__meta-icon-col-remove">
        {rowIndex > 0 ? (
          <button
            onClick={(e) => onRemoveClick(e, rowIndex)}
            className="search-advanced__remove-icon"
            type="button"
          >
            <CloseIcon width={24} height={24} stroke="#d65544" aria-label="Close" />
          </button>
        ) : null}
      </div>
    </Row>
  );
}
SearchAdvancedRow.propTypes = {
  metatagOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onRemoveClick: PropTypes.func,
  rowIndex: PropTypes.number,
  onDataChange: PropTypes.func,
  searchTerm: PropTypes.oneOfType([
    PropTypes.instanceOf(SearchTerm),
    PropTypes.instanceOf(AdvancedSearchTerm),
  ]),
};

export default injectIntl(SearchAdvancedRow);
